(function () {
  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = 'Cart (' + cart.item_count + ')';
        });
      })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', updateCartCount);
  document.addEventListener('product-ajax:added', updateCartCount);

  // Open the theme's existing cart drawer instead of navigating to /cart —
  // mirrors what MCartDrawer (assets/cart.js) does for .m-cart-icon-bubble,
  // without pulling in that class's old-header spacing/padding rules.
  // Absent on the cart page itself and when the drawer setting is off, in
  // which case the link's normal href navigation is left alone.
  document.querySelectorAll('[data-cart-count]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var drawer = document.querySelector('m-cart-drawer');
      if (!drawer || !window.MinimogSettings || !window.MinimogSettings.enable_cart_drawer) return;
      event.preventDefault();
      drawer.open(link);
    });
  });

  // Mobile hamburger — toggles the same nav (Shop + Our story) that's just an
  // inline row on wider screens; see the mobile-only rules in
  // editorial-shell.css for how .is-open is styled.
  document.querySelectorAll('[data-ed-menu-toggle]').forEach(function (toggle) {
    var nav = document.getElementById(toggle.getAttribute('aria-controls')) || toggle.closest('.ed-header').querySelector('[data-ed-header-nav]');
    if (!nav) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('ed-nav-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!nav.classList.contains('is-open'));
    });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && !toggle.contains(e.target)) setOpen(false);
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) setOpen(false);
    });
  });
})();
